<template>
  <!--<form action="https://postman-echo.com/post" method="post">-->
  <v-container>
    <form>
      <v-layout v-if="!lockout">
        <v-flex xs12>
          <v-card
            v-for="(q, index) in questions"

            :key="index"
          >
            <div v-if="step == index + 1">
            <v-toolbar  color="blue darken-3" dark>
              <v-toolbar-title
                >NQSTIP Assessment for Inspectors</v-toolbar-title
              >
            </v-toolbar>

            <v-card-title primary-title>
              <div>
                <div class="pb-3 blue--text subtitle-1 font-weight-bold">
                  Note that you have only two attempts at this test. There are
                  10 questions. Some questions may require answers in decimal numbers
                  correct to one decimal place. Other questions are multiple
                  choice. Some questions may have up to 9 answer options. Scroll
                  through the answer option drop down to make sure you can see
                  them. Please read all the questions carefully.
                </div>
                <div class="pb-3 blue--text subtitle-1 font-weight-bold " v-if="passing">
                  Status: You have cleared the test.
                </div>
                <div class="pb-3 blue--text subtitle-1 font-weight-bold" v-if="!passing">
                  Status: You have not cleared the test.
                </div>
                <div class="pb-3 blue--text subtitle-1 font-weight-bold">Attempts: {{ attempts }}</div>

                <div class="body-1 mb-0">Question {{ index + 1 }}</div>
                <div class="body-1 " >{{ q.text }}</div>
              </div>
            </v-card-title>

            <v-layout align-center justify-start row fill-height>
              <v-img class="pl-4 pr-4"
                v-if="q.image1"
                left
                max-height="350px"
                contain
                lazy-src="Loading ..."
                :src="require('@/assets/' + q.image1 + '.png')"
              >
                <template v-slot:placeholder>
                  <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                  >
                    <v-progress-circular
                            indeterminate
                            color="grey"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-img
                v-if="q.image2"
                left
                max-height="350px"
                contain
                :src="require('@/assets/' + q.image2 + '.png')"
              ></v-img>
            </v-layout>

            <v-card-text></v-card-text>

            <v-text-field
                    type="number"

              v-if="q.textinput"
              v-model="q.measure"
              class="pa-5"
              label="Answer"
              :mask="mask"
            ></v-text-field>

            <v-select
              v-if="q.dropdown"
              class="pa-5"
              v-model="q.answer"
              :items="q.answers"
              clearable
              label="Answer"
            ></v-select>

            <p
              class="pl-5 pr-5 pt-5 blue--text"
              v-if="index == questions.length - 1"
            >
              {{ text }}
            </p>
            <p
              class="pl-5 pr-5 pb-5 blue--text"
              v-if="index == questions.length - 1 && incorrect.length > 0"
            >
              Questions you got wrong {{ incorrect }}
            </p>
            <v-layout
              row
              fill-height
              justify-center
              align-center
              v-if="loading"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-layout>

            <v-card-actions>
              <v-btn
                v-if="index > 0 && index < questions.length"
                @click.prevent="prev()"
                >Previous</v-btn
              >
              <v-btn v-if="index < questions.length - 1" @click.prevent="next()"
                >Next</v-btn
              >
              <v-btn
                color="primary"
                v-if="index == questions.length - 1"
                @click="submitResults"
              >
                Submit Assessment</v-btn
              >
            </v-card-actions>
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout v-if="!lockout">
        <v-flex xs12>
          <v-card v-if="step == 11">
            <v-toolbar  color="blue darken-3" dark>
              <v-toolbar-title
                >NQSTIP Assessment for Inspectors</v-toolbar-title
              >
            </v-toolbar>

            <v-card-title primary-title>
              <div>
                <h3 class="pb-3 blue--text" v-if="result && !loading">
                  You have passed the test!
                </h3>
                <h3 class="pb-3 red--text" v-if="!result && !loading">
                  You have not passed the test!
                </h3>
              </div>
            </v-card-title>
            <v-card-text></v-card-text>
            <p class="pl-5 pr-5 pb-5 blue--text" v-if="incorrect.length > 0">
              Questions you got wrong {{ incorrect }}
            </p>
            <v-layout
              row
              fill-height
              justify-center
              align-center
              v-if="loading"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-layout>

            <v-snackbar
              v-model="success"
              top
              left
              :timeout="timeout"
              color="green"
            >
              Congratulations you have passed the test!
            </v-snackbar>

            <v-snackbar
              v-model="failure"
              top
              left
              :timeout="timeout"
              color="red"
            >
              You have not passed!
            </v-snackbar>

            <v-card-actions>
              <v-btn color="primary" @click="restart()">
                Restart Assessment</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout v-if="lockout">
        <h3>Oops! You have been locked out of the assessment.</h3>
      </v-layout>
    </form>
    <v-snackbar v-model="notification" top left :timeout="timeout">
      {{ errText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import jwt_decode from "jwt-decode";
import { router } from "../router";
import { config } from "../config/config";
import { checkLogin } from '../helpers/check'

export default {
  name: "Nav",
  data() {
    return {
      errText: "Oops! Something went wrong",
      timeout: 6000,
      notification: false,
      portalUrl: config.insApiUrl,
      lockout: false,
      id: "",
      username: "",
      step: 1,
      mask: "#.#",
      results: {},
      result: false,
      failure: false,
      success: false,
      incorrect: [],
      loading: false,
      passing: false,
      attempts: 0,
      count: 10,
      text: "Please be careful and check your answers before submission. You only have two attempts at this test.\n" +
        "                        You have to answer all the questions correctly to pass. ",
      registration: {
        name: null,
        email: null,
        street: null,
        city: null,
        state: null,
        numtickets: 0
      },
      questions: [
          {
              text:
              "What is the approximate distance to salt water for the address " +
              "'20 Seafarer St, South Mission Beach, Queensland'",
              image1: null,
              image2: null,
              textinput: false,
              dropdown: true,
              answers: [
                  "Less than 100 m",
                  "100 to 200 m",
                  "200 to 500 m",
                  "More than 500 m"
              ],
              range: [],
              answer: "",
              measure: "",
              id: 4,
              index : 1,
              correctAnswers: ["Less than 100 m"],
              textAnswer: true,
              rangeAnswer: false,
              numberAnswer: false
          },
       {
          text:
            "What is the elevation of the lowest occupied floor (m AHD) for " +
            "'Sanctuary Palm Cove 6 Cedar Road, Palm Cove, (Cairns) Queensland'. " +
            " " +
            "" +
            "The lowest occupied floor is represented by the red circle on the image. " +
            "Give answer to the nearest 0.2 m. (Follow the details for downloading the " +
            "contour maps in the User Guide and overlay them on the Google Earth image to " +
            "identify the contours and interpolate to get the height.)",
          image1: "Picture1",
          image2: "",
          textinput: true,
          dropdown: false,
          answers: [
          ],
          range: [],
          answer: "",
          measure: "",
          id: 9,
          index : 2,
          correctAnswers: [4.2, 4.6],
          textAnswer: false,
          rangeAnswer: true,
          numberAnswer: false
        },
        {
          text:
            "What is the Highest Astronomical Tide (AHD)\n" +
            "of the property at 'Golden Orchard Drive, Airlie Beach'. \n",
          image1: "",
          image2: "",
          textinput: true,
          dropdown: false,
          answers: [],
          range: [],
          answer: "",
          measure: "",
          id: 19,
          index : 3,
          correctAnswers: [2.19],
          textAnswer: false,
          rangeAnswer: true,
          numberAnswer: false
        },
        {
          text:
            "What material is used for fences within or around the property? HINT: This question has 9 answer options. Scroll through the options to see all of them.",
          image1: "Picture2",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No fences",
            "Fibre cement",
            "Glass",
            "Timber",
            "Profiled sheet metal",
            "Tubular metal fencing",
            "Chain mesh",
            "Masonry",
            "Material other than those listed"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 82,
          index : 4,
          correctAnswers: ["Timber"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Condition of fences (corrosion, rot, connections, footings).\n" +
            "Photo below is typical of entire grounds.",
          image1: "Picture3",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No fences",
            "Worn out",
            "Poor condition",
            "Generally good condition",
            "As new condition"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 83,
          index : 5,
          correctAnswers: ["Generally good condition", "As new condition"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Number of large trees (> 6 m tall) within 5 or 6 m of building. Assess how many of the trees in the photo are big and close enough.",
          image1: "Picture4",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
              "1 not a coconut palm",
              "2 and not coconut palms",
              "3 to 5 and none are coconut palms",
              "6 to 10 and none are coconut palms",
              "More than 10 and none are coconut palms",
              "Any number of trees including coconut palms"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 11,
          index : 6,
          correctAnswers: ["3 to 5 and none are coconut palms"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false

        },
        {
          text:
            "Does the building have eave/perimeter gutters?\n" +
            "Photo is typical of entire building.\n",
          image1: "Picture5",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: ["No", "Some roof edges", "All roof edges"],
          range: [],
          answer: "",
          measure: "",
          id: 33,
          index : 7,
          correctAnswers: ["All roof edges"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false

        },
        {
          text:
            "On the elevation with the highest percentage of windows or glazed openings, roughly what is that percentage? (Photo is typical of this elevation of building.)",
          image1: "Picture6",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No windows or openings",
            "1% to 20%",
            "20% to 40%",
            "40% to 60%",
            "60% to 80%",
            "80% to 100%"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 54,
          index : 8,
          correctAnswers: ["40% to 60%", "60% to 80%",],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "What type of debris protection is on external doors that incorporate glass?\n" +
            "Photo is typical of doors throughout building. HINT: This question has 8 answer options. Scroll through the options to see all of them.\n",
          image1: "Picture7",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
              "No doors that incorporate glass",
              "No debris protection on doors that incorporate glass",
              "Temporary debris shutters will be fitted to less than 50% of the glass door area as part of the preparation for a cyclone",
              "Temporary debris shutters will be fitted to more than 50% of the glass door area as part of the preparation for a cyclone",
              "Lightweight screens on 50% or less of glass door area",
              "Lightweight screens on more than 50% of glass door area",
              "Strong screens (heavy gauge steel, concrete or masonry) on 50% or less of glass door area",
              "Strong screens (heavy gauge steel, concrete or masonry) on more than 50% of glass door area",
          ],
          range: [],
          answer: "",
          measure: "",
          id: 62,
          index : 9,
          correctAnswers: ["No debris protection on doors that incorporate glass"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "What is the garage door type? HINT: This question has 7 answer options. Scroll through the options to see all of them.",
          image1: "Picture10",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
              "No garage doors",
              "Tilt",
              "Rolling curtain door",
              "Concertina or hinged",
              "Roller shutter",
              "Sectional or panel lift door",
              "Steel gate or horizontal sliding"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 67,
          index : 10,
          correctAnswers: ["Sectional or panel lift door"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            " Condition of window seals: \n" +
            "Use photo below to determine the condition of the window seals.\n",
          image1: "Picture11",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No windows",
            "No window seals",
            "Worn out",
            "Poor condition",
            "Generally good condition",
            "As new condition"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 58,
          index : 11,
          correctAnswers: ["Worn out"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Best view from the building: \n" +
            "Use photo below as view from the building. \n",
          image1: "Picture12",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No view",
            "View beyond a few other properties",
            "View beyond 500 metres, but less than 5 km",
            "View beyond suburb/town or over the ocean (more than 5 kilometres)"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 10,
          index : 12,
          correctAnswers: ["View beyond suburb/town or over the ocean (more than 5 kilometres)"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Condition of visible timber and steel in the roof space (corrosion, rot): Photo is just outside roof space but typical of what is in the roof space.",
          image1: "Picture13",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
              "Unable to inspect",
              "No roof space and clad roof",
              "Concrete slab roof with no roof space",
              "Rot or corrosion extensive",
              "Rot or corrosion starting",
              "Generally good condition",
              "As new condition"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 48,
          index : 13,
          correctAnswers: ["Generally good condition"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Are roof fastenings to manufacturers' specifications?\n" +
            "Use the photo below. Building is 12 m high. If necessary, estimate spacings and compare with summary tables in Inspection Manual.\n" +
            "\n",
          image1: "Picture14",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "Unable to inspect",
            "No visible roof fasteners in the roofing system",
            "All roof areas have incorrect fasteners or inadequate spacing",
            "All general areas have correct fasteners and spacing but edge areas have inadequate spacing or fasteners",
            "Most fasteners in general and edge areas are correct type and spacing",
            "All fasteners in spec"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 89,
          index : 14,
          correctAnswers: ["No visible roof fasteners in the roofing system"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Condition of roofing and roof fasteners: \n" +
            "Use the photo below to determine the roofing and fastener condition.\n",
          image1: "Picture15",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "Unable to inspect",
            "Worn out",
            "Poor condition",
            "Generally good condition",
            "As new condition"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 23,
          index : 15,
          correctAnswers: ["Poor condition", "Worn out"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Are roof flashings adequately fixed? (Spacing and type of fasteners) Use the photo below with flashing depth 250 mm.",
          image1: "Picture16",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No roof flashings",
            "Unable to inspect",
            "Some faces of flashing are not fastened",
            "At least one face fastened with pop rivets",
            "All faces fastened with screws but spacings are too large",
            "All faces fastened with screws that are adequately spaced"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 90,
          index : 16,
          correctAnswers: ["All faces fastened with screws but spacings are too large"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Number of valley gutters: \n" +
            "Use photo below to determine number of valley gutters on the building. \n",
          image1: "Picture18",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "No valley gutters",
            "1",
            "2",
            "3 to 5",
            "More than 5",
            "No box gutters"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 36,
          index : 17,
          correctAnswers: ["More than 5"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false

        },
        {
          text:
            "Approximate roof area: \n" +
            "Check the roof area of the building in the attached photo. The address is the corner of Park St and Gladstone St in Pimlico, Townsville.\n",
          image1: "Picture20",
          image2: "",
          textinput: false,
          dropdown: true,
          answers: [
            "less than 100 metre square",
            "100  metre square to 200  metre square",
            "200  metre square to 500  metre square",
            "500 metre square to 1000  metre square",
            "1000  metre square to 2000  metre square",
            "greater than 2000 metre square"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 91,
          index : 18,
          correctAnswers: ["500 metre square to 1000  metre square"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
          text:
            "Condition of gutters and drainage systems (blockage with detritus)\n" +
            "Photo is the worst condition on the building.\n",
          image1: "Picture21",
          textinput: false,
          dropdown: true,
          answers: [
            "No gutters or down pipes",
            "Unable to inspect with no regular check and clean program for gutters",
            "Unable to inspect but there is a regular check and clean program for gutters",
            "Completely blocked",
            "Partially blocked",
            "Generally good condition",
            "As new condition"
          ],
          range: [],
          answer: "",
          measure: "",
          id: 40,
          index : 19,
          correctAnswers: ["Completely blocked"],
          textAnswer: true,
          rangeAnswer: false,
          numberAnswer: false
        },
        {
            text:
                "Does the building have a basement?",
            image1: "Picture22",
            textinput: false,
            dropdown: true,
            answers: [
                "No",
                "Yes"
            ],
            range: [],
            answer: "",
            measure: "",
            id: 16,
            index : 20,
            correctAnswers: ["Yes"],
            textAnswer: true,
            rangeAnswer: false,
            numberAnswer: false
        },
        {
            text:
                "What type of debris protection is on the windows?",
            image1: "Picture23",
            textinput: false,
            dropdown: true,
            answers: [
                "No windows",
                "No debris protection",
                "Temporary debris shutters will be fitted to less than 50% of the window area as part of the preparation for a cyclone",
                "Temporary debris shutters will be fitted to more than 50% of the window area as part of the preparation for a cyclone",
                "Lightweight screens, debris rated glass or security film on 50% or less of window area",
                "Lightweight screens, debris rated glass or security film on more than 50% of window area",
                "Strong screens (heavy gauge steel, concrete or masonry) on 50% or less of window area",
                "Strong screens (heavy gauge steel, concrete or masonry) on more than 50% of window area"
            ],
            range: [],
            answer: "",
            measure: "",
            id: 57,
            index : 21,
            correctAnswers: ["Lightweight screens, debris rated glass or security film on more than 50% of window area"],
            textAnswer: true,
            rangeAnswer: false,
            numberAnswer: false
        },
        {
            text:
                "Do any doors have downpipes that discharge onto any surface within 1 metre of a door? Assume that the photo is typical of downpipe location in all parts of the building.",
            image1: "Picture24",
            textinput: false,
            dropdown: true,
            answers: [
                "All doors do",
                "Some doors do",
                "No doors do"
            ],
            range: [],
            answer: "",
            measure: "",
            id: 35,
            index : 22,
            correctAnswers: ["No doors do"],
            textAnswer: true,
            rangeAnswer: false,
            numberAnswer: false
        },
        {
            text:
                "How many types of buildings are there on this property? The boundary of the property is defined by the red rectangle.",
            image1: "Picture25",
            textinput: true,
            dropdown: false,
            answers: [],
            range: [],
            answer: "",
            measure: "",
            id: 0,
            index : 23,
            correctAnswers: [3],
            textAnswer: false,
            rangeAnswer: false,
            numberAnswer: true
        },
        {
            text:
                "How porous are the garage doors?",
            image1: "Picture26",
            textinput: false,
            dropdown: true,
            answers: [
                "There are no garage doors",
                "Solid (not porous) garage doors not in the basement",
                "Porous garage doors not in the basement",
                "Solid (not porous) garage doors in the basement",
                "Porous garage doors in the basement"
            ],
            range: [],
            answer: "",
            measure: "",
            id: 69,
            index : 24,
            correctAnswers: ["Porous garage doors in the basement"],
            textAnswer: true,
            rangeAnswer: false,
            numberAnswer: false
        }
      ],
      answers: [
        "100 to 200 m",
        "",
        "",
        "Timber",
        "Generally good condition",
        "3 to 5",
        "All roof edges",
        "60% to 80%",
        "No debris protection on any doors that incorporate glass",
        "Yes",
        "Sectional slotted (permeable) panel",
        "Worn out",
        "View beyond suburb/town or over the ocean (more than 5 kilometres)",
        "Generally good condition",
        "All fasteners in spec", //14
        "Generally good condition",
        "All faces fastened with screws but spacings are too large",
        "More than 5",
        "500 metre square to 1000  metre square",
        "Partially blocked"
      ]
    };
  },
  mounted() {
    this.checkLoggedIn();
    this.questions= this.shuffle(this.questions)
    this.questions = this.questions.slice(0, 10)
  },
  methods: {
      shuffle(array) {
          var currentIndex = array.length, temporaryValue, randomIndex;

          // While there remain elements to shuffle...
          while (0 !== currentIndex) {

              // Pick a remaining element...
              randomIndex = Math.floor(Math.random() * currentIndex);
              currentIndex -= 1;

              // And swap it with the current element.
              temporaryValue = array[currentIndex];
              array[currentIndex] = array[randomIndex];
              array[randomIndex] = temporaryValue;
          }

          return array;
      },
      restart() {
      window.location.reload();
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
      //console.log(this.step)
    },
    submit() {},
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/ins-login");
      }
      else {
        this.retrieveUser();
      }
    },
    checkResults_() {
      let pass = true;

      for (let i = 0; i < this.questions.length; i++) {
        let val = this.questions[i].measure;
        if (val >= 10) val = val / 10;
        let j = i + 1;
        this.results["question_" + j] = this.questions[i].answer;

        if (i === 1) {
          this.results["question_" + j] = val;
          if (!(4.2 <= parseFloat(val) && parseFloat(val) <= 4.6)) {
            pass = false;
            this.incorrect.push(i + 1);
          }
        } else if (i === 2) {
          this.results["question_" + j] = val;
          if (!(2.0 <= parseFloat(val) && parseFloat(val) <= 2.2)) {
            pass = false;
            this.incorrect.push(i + 1);
          }
        } else if (i === 7) {
          if (
            !(
              "60% to 80%" == this.questions[i].answer ||
              "40% to 60%" == this.questions[i].answer
            )
          ) {
            pass = false;
            this.incorrect.push(i + 1);
          }
        } else if (i === 14) {
          //this.results["question_"+j]= this.questions[i].answer;
          if (
            !(
              "All fasteners in spec" == this.questions[i].answer ||
              "Most fasteners in general and edge areas are correct type and spacing" ==
                this.questions[i].answer
            )
          ) {
            pass = false;
            this.incorrect.push(i + 1);
          }
        } else if (!(this.questions[i].answer === this.answers[i])) {
          //this.results["question_"+j]= this.questions[i].answer;
          pass = false;
          this.incorrect.push(i + 1);
        }
      }
      return pass;
    },
    checkResults() {
          let pass = true;
          for (let i = 0; i < 10; i++) {
              //convert numbers properly
              let val = this.questions[i].measure;
              if (val >= 10) val = val / 10;
              let j = i + 1;
              this.results["question_" + j] = this.questions[i].answer + ', qid:'+ parseInt(this.questions[i].id)+ ', test id:'+ parseInt(this.questions[i].index);
              if (this.questions[i].index === 2) {
                  this.results["question_" + j] = val + ', qid:'+ parseInt(this.questions[i].id)+ ', test id:'+ parseInt(this.questions[i].index);
                  if (!(4.2 <= parseFloat(val) && parseFloat(val) <= 4.6)) {
                      pass = false;
                      this.incorrect.push(i + 1);
                  }
              } else if (this.questions[i].index === 3) {
                  this.results["question_" + j] = val  + ', qid:'+ parseInt(this.questions[i].id)+ ', test id:'+ parseInt(this.questions[i].index);
                  if (!(2.18 < parseFloat(val) && parseFloat(val) <= 2.20)){
                      pass = false;
                      this.incorrect.push(i + 1);
                  }
              }
              else if (this.questions[i].index === 23) {
                  this.results["question_" + j] = val + ', qid:'+ parseInt(this.questions[i].id)+ ', test id:'+ parseInt(this.questions[i].index);
                  if (!( 3 === parseFloat(val) )) {
                      pass = false;
                      this.incorrect.push(i + 1);
                  }
              } else if (!(this.questions[i].correctAnswers.includes(this.questions[i].answer))) {
                  pass = false;
                  this.incorrect.push(i + 1);
              }
          }
          return pass;
      },
    submitResults() {
      this.next();
      let pass = true;
      this.incorrect = [];
      this.results = {};

      pass = this.checkResults();
      if (!pass) {
        this.failure = true;
      } else {
        this.success = true;

      }


     axios.defaults.headers.common["Authorization"] =
        "JWT " + sessionStorage.getItem("token");
      this.loading = true;
      this.results["inspector"] = this.id;
      axios
        .post(this.portalUrl + "tests/", this.results)
        .then(res => {
          axios
            .put(this.portalUrl + "ins/" + this.id + "/", {
              username: this.username,
              passing: pass
            })
            .then(res => {
              this.loading = false;
              this.result = pass;
              //this.results ={};
            })
            .catch(e => {
              this.loading = false;
              this.notification = true;
              //this.results ={};
            });
        })
        .catch(e => {
          this.loading = false;
          this.notification = true;
          //this.results ={};
        });
    },
    retrieveUser() {
      axios.defaults.headers.common["Authorization"] =
        "JWT " + sessionStorage.getItem("token");
      this.loading = true;
      axios
        .get(this.portalUrl + "current-user/")
        .then(res => {
          this.id = res.data.id;
          this.username = res.data.username;
          this.passing = res.data.passing;
          this.attempts = res.data.attempts;
          if (res.data.attempts == 2 && !res.data.passing) this.lockout = true;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.notification = true;
        });
    }
  }
};
</script>
